export default __webpack_public_path__ + "static/media/sunny.25021c58.gif";